import gql from "graphql-tag"
import MediaRevisionFragment from "../fragment/MediaRevisionFragment"

export default gql`
  ${MediaRevisionFragment}
  mutation mediaUpgradeCancel($revisionId: String!) {
    revision: mediaUpgradeCancel(revisionId: $revisionId) {
      ...MediaRevisionFragment
    }
  }
`
